@let transactionHistoryGroups = transactionHistoryGroups$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="{{defaultBackHref}}/profile/{{profileId}}"></ion-back-button>
    </ion-buttons>
    <ion-title>Transaction History</ion-title>
  </ion-toolbar>
</red-header-content>
<red-page-content [paddingBottom]="true">
  @if (transactionHistoryGroups && transactionHistoryGroups.length) {
  <ion-list [inset]="true" class="no-last-line">
    <ion-accordion-group>
      @for (transactionHistoryGroup of transactionHistoryGroups; track transactionHistoryGroup; let i = $index) {
      <ion-item-divider>
        <ion-label> {{transactionHistoryGroup.title}} </ion-label>
      </ion-item-divider>
      @for (transactionHistoryItem of transactionHistoryGroup.data; track transactionHistoryItem; let j = $index) {
      <ion-accordion value="{{i}}{{j}}">
        <ion-item slot="header">
          <ion-label>{{transactionHistoryItem.title}}</ion-label>
        </ion-item>
        <ion-list slot="content" lines="full">
          @if ((documentLinksEnabled$ | async)) { @if (transactionHistoryItem.showDocumentNumber) {
          <ion-item (click)="sendDocument(transactionHistoryItem)" [button]="true" [detail]="false">
            <ion-icon color="primary" slot="start" name="document-attach-outline"></ion-icon>
            <ion-label color="medium">
              Document No<br />
              <ion-note color="primary" class="tw:font-bold tw:text-wrap">
                {{transactionHistoryItem.DocumentNum | redDashIfEmpty}}
              </ion-note>
            </ion-label>
            <ion-icon color="primary" slot="end" name="cloud-download-outline"></ion-icon>
          </ion-item>
          } } @else { @if (transactionHistoryItem.showDocumentNumber) {
          <ion-item [button]="false" [detail]="false">
            <ion-icon color="primary" slot="start" name="document-attach-outline"></ion-icon>
            <ion-label color="medium">
              Document No<br />
              <ion-note color="primary" class="tw:font-bold tw:text-wrap">
                {{transactionHistoryItem.DocumentNum | redDashIfEmpty}}
              </ion-note>
            </ion-label>
          </ion-item>
          } }
          <ion-item>
            <ion-label color="medium">
              Type of Sale<br />
              <ion-note color="dark" class="tw:font-bold tw:text-wrap">
                {{transactionHistoryItem.TypeOfSale | redDashIfEmpty}}
              </ion-note>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-label color="medium">
              Price<br />
              <ion-note color="dark" class="tw:font-bold tw:text-wrap">
                {{transactionHistoryItem.Price | redCurrency}}
              </ion-note>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-label color="medium">
              First TD<br />
              <ion-note color="dark" class="tw:font-bold tw:text-wrap">
                {{transactionHistoryItem.FirstTD | redCurrency}}
              </ion-note>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-label color="medium">
              Seller Name<br />
              <ion-note color="dark" class="tw:font-bold tw:text-wrap">
                {{transactionHistoryItem.SellerName | redDashIfEmpty}}
              </ion-note>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-label color="medium">
              Buyer Name<br />
              <ion-note color="dark" class="tw:font-bold tw:text-wrap">
                {{transactionHistoryItem.BuyerName | redDashIfEmpty}}
              </ion-note>
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-accordion>
      } }
    </ion-accordion-group>
  </ion-list>
  }
</red-page-content>
